
  <div data-content="one" class="consultant-list-tab take-action-tab active">
    <div class="omne-card full-details">
       <div class="full-details-header bb-1 col-lg-12 d-flex flex-wrap justify-content-between pdy-2 pdx-0">
          <div class="col-lg-8 pd-0 pdx-0 d-flex flex-wrap">
            <div class="col-lg-4 pd-0 pdx-2">
               <div class="form-group mg-0">
                  <label for="SelectDocument">Estimated Start Date</label>
                  <span class="has-icon">
                     <input type="text" placeholder="Select Date Range" class="form-control"
                     #drp="bsDaterangepicker" bsDaterangepicker placement="bottom left"
                     [(ngModel)]="SelectedEsdDate" name="esdRange"
                         
                     [bsConfig]="{ containerClass:'theme-blue' }"
                     >
                    <i class="con fa-light fa-calendar-days font-16 cursor-pointer pdr-2 text-color-action" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen">
                      <!-- <img src="./images/icons/ic-bottom-arrow.svg"> -->
                    </i>
                  </span>
                  <div *ngIf="DateRangeError" class="text-danger">
                     <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                     {{DateRangeErrorMessage}}
                 </div>
                </div>
            </div>
            <div class="col-lg-5 col-xl-6 pd-0 pdx-2">
                <div class="form-group mg-lg-0 mgb-3">
                   <label for="">&nbsp;</label>
                   <span [ngClass]="advanceSearchPopupCSS">
                      <input type="text" id="ERName"  class="text_12 form-control"
                         placeholder="Search by Ascendion ID, Candidate Name, Client Name" [(ngModel)]="AdvanceSearch.CandidateName" value="">
                      <i class="con pe-all cursor-pointer pdx-2" style="right: 27px;">
                         <img src="../assets/images/icons/ic-search.svg" (click)="AdvanceSearchClick()" alt="ic-search">
                      </i>
                      <i class="con js_dropdown_container_handler pe-all cursor-pointer" data-tooltip="Advance Filters" data-tooltip-location="bottom">
                         <img src="../assets/images/icons/ic-bottom-arrow.svg" (click)="changeCSSAdvancefilterPopup()"  alt="ic-search">
                      </i>
                      <div class="dropdown-container advance-filter-block omne-card pd-0 mg-0 pdt-2 pdb-3">
                         <div class="advance-filter-header col-12 pd-0">
                            <h4 class="mg-0 pdx-3 pdy-2 mgb-2">
                               Filters
                               <i class="close"><img src="../assets/images/icons/ic-close.svg" alt="ic-search" style="width:10px; height: 10px;"></i>
                            </h4>
                         </div>
                         <div class="advance-filter-body col-12 pd-0 d-flex flex-row flex-wrap">
                           
                            <div class="col-md-12 col-lg-6 pd-0 pdx-3">
                               <div class="form-group">
                                  <label for="SelectDocument">Client Name</label>
                                  <span class="has-icon">
                                    <ng-select name="ClientList" [items]="ClientList"
                                    bindLabel="itemName"
                                    bindValue="itemName" [closeOnSelect]="true"
                                    [(ngModel)]="AdvanceSearch.ClientNames"
                                    id='searchClientName'
                                    [ngModelOptions]="{standalone: true}"
                                    [multiple]="true" >
                                        <ng-option *ngFor="let item of ClientList" [value]="item.itemName" >{{item.itemName}}</ng-option>
                                    </ng-select>
                                     <i class="con">
                                        <img src="../assets/images/icons/ic-bottom-arrow.svg">
                                     </i>
                                  </span>
                               </div>
                            </div>
                            <div class="col-md-12 col-lg-6 pd-0 pdx-3">
                               <div class="form-group">
                                  <label for="SelectDocument">End Client Name</label>
                                  <span class="has-icon">
                                    <ng-select name="EndClientList" [items]="EndClientList"
                                    bindLabel="itemName"
                                    bindValue="itemName" [closeOnSelect]="true"
                                    [(ngModel)]="AdvanceSearch.EndClientName"
                                    id='searchEndClientName'
                                    [ngModelOptions]="{standalone: true}"
                                    [multiple]="true" >
                                        <ng-option *ngFor="let item of EndClientList" [value]="item.itemName" >{{item.itemName}}</ng-option>
                                    </ng-select>
                                     <i class="con">
                                        <img src="../assets/images/icons/ic-bottom-arrow.svg">
                                     </i>
                                  </span>
                               </div>
                            </div>
                            <div class="col-md-12 col-lg-6 pd-0 pdx-3">
                               <div class="form-group">
                                  <label for="SelectDocument">OPS Executive</label>
                                  <span class="has-icon">
                                    <ng-select name="OpsExecutiveList" [items]="OpsExecutiveList"
                                            bindLabel="itemName"
                                            bindValue="itemName" [closeOnSelect]="true"
                                            [(ngModel)]="AdvanceSearch.OPSExecutives"
                                            id='searchOpsExecutive'
                                            [ngModelOptions]="{standalone: true}"
                                            [multiple]="true" >
                                                <ng-option *ngFor="let item of OpsExecutiveList" [value]="item.itemName" >{{item.itemName}}</ng-option>
                                            </ng-select>
                                     <i class="con">
                                        <img src="../assets/images/icons/ic-bottom-arrow.svg">
                                     </i>
                                  </span>
                               </div>
                            </div>
                            <div class="col-md-12 col-lg-6 pd-0 pdx-3">
                               <div class="form-group">
                                  <label for="" class="">Status</label>
                                  <div class="form-check-inline height-35">
                                     <label class="form-check-label mg-0">
                                        <input type="radio" class="form-check-input" [(ngModel)]="wfstatus"  (change)="changeStatus($event)" value="1" name="optradio"> Active
                                     </label>
                                  </div>
                                  <div class="form-check-inline height-35">
                                     <label class="form-check-label mg-0">
                                        <input type="radio" class="form-check-input" [(ngModel)]="wfstatus"  (change)="changeStatus($event)" value="0" name="optradio"> Inactive
                                     </label>
                                  </div>
                               </div>
                            </div>
                            <div class="clear-fix clearfix"></div>
                         </div>
                         <div class="advance-filter-footer col-12 pd-0">
                            <div class="form-group mg-0 pd-0 pdx-3 text-right">
                               <button class="obtn obtn-outline obtn-reg" (click)="ResetSearchFields()">Reset</button>
                               <button class="obtn obtn-primary obtn-reg mgl-3" (click)="AdvanceSearchClick()">Apply</button>
                            </div>
                            <div class="clear-fix clearfix"></div>
                         </div>
                      </div>
                   </span>
                </div>
             </div>
             <div class="col-lg-3 col-xl-2 pdx-2 pdx-lg-0">
                <div class="form-group mg-0">
                   <label class="mgb-2 d-none d-lg-block" for="">&nbsp;</label>
                   <button class="obtn obtn-primary obtn-sm" (click)="AdvanceSearchClick()">Search</button>&nbsp;
                   <button class="obtn obtn-outline obtn-sm" (click)="ResetSearchFields()">Reset</button>
                </div>
             </div>
          </div>
          <div class="activeInactive-block col-lg-3 pd-0 pdr-4 d-flex flex-wrap align-items-center justify-content-end">
             <div class="form-group mg-0 col-12 pd-0 text-right">
                <label for="">&nbsp;</label>
                <span [ngClass]="candidateStatus==1 ?'activeInactive--modifier active font-12 font-lg-16 font-weight-500 pdx-2 cursor-pointer active':'activeInactive--modifier font-12 font-lg-16 font-weight-500 pdx-2 cursor-pointer'" (click)="GetConsltantListAccordingToStatus(1, $event)"  data-tooltip="Active Consultants" data-tooltip-location="bottom">
               <span class="text-color-action"><i Class="fa-solid fa-square-caret-right"></i> Active </span> &nbsp;
                  <b class="text-color-pink">{{this.totalActiveConsCount}}</b></span>
                <span [ngClass]="candidateStatus==0 ?'activeInactive--modifier font-12 font-lg-16 font-weight-500 pdl-2 cursor-pointer active':'activeInactive--modifier font-12 font-lg-16 font-weight-500 pdl-2 cursor-pointer'" (click)="GetConsltantListAccordingToStatus(0, $event)"  data-tooltip="InActive Consultants" data-tooltip-location="bottom">
                  <span class="text-color-action"><i Class="fa-solid fa-square-caret-right"></i> Inactive </span> &nbsp;
                  <b class="text-color-pink">{{this.totalInactiveCount}}</b></span>
             </div>
             
          </div>
          <div class="col-lg-1 form-group mg-0">
            <label for="">&nbsp;</label>
            <h4 class="mg-0 pd-0 pdb-2 text-right">
               <span class="mg-0" data-tooltip="Export to excel" data-tooltip-location="left">
                  <a (click)="ExportToExcel()">
                     <img src="../assets/images/icons/ic-excel.svg" alt="ic-excel">
                  </a>
               </span>
             </h4>
          </div>
       </div>
      

       <div class="full-details-body col-lg-12 pd-2">
          
            <!-- (scroll)="onTableScroll($event)" HArsh -->
            <div class="table_wrap xre_table standard-table pd-0 table-respo consultant-list--table">
                <mat-table [dataSource]="candidateList" #table id="table" (scroll)="onTableScroll($event)" role="grid"  matSort>
                    <ng-container [matColumnDef]="column.field" *ngFor="let column of cols">
    
    
                        <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="column.hcss" type="text" >
                            {{column.header}}
                        </mat-header-cell>
        
                        <mat-cell *matCellDef="let element;" [ngClass]="column.bcss" >
                           
                            <!-- <div *ngIf="column.field=='Status'" data-toggle="tooltip" data-placement="top" title="{{element[column.field]}}">
                            </div>-->
                            <span style="width:100%;word-wrap:break-word;white-space: nowrap;overflow: hidden;  text-overflow: ellipsis;" data-toggle="tooltip" data-placement="top" title="{{element[column.field]}}">
                                {{element[column.field]}}
                            </span> 
                            <span *ngIf="column.field=='candidateName'" style="width:100%;word-wrap:break-word;white-space: nowrap;overflow: hidden;width: 174px;color: black; text-overflow: ellipsis;" data-toggle="tooltip" data-placement="top" title="{{element.gci_Id}}"> {{element.gci_Id}}</span>
                            <span  style="width:100%;word-wrap:break-word;white-space: nowrap;overflow: hidden;color: black;width: 174px; height: 20px; text-overflow: ellipsis;" *ngIf="column.field=='clientName'" data-toggle="tooltip" data-placement="top" title="{{element.endClientName}}"> {{element.endClientName}}</span>
                            
                            <!-- <span  style="word-wrap:break-word;white-space: nowrap;overflow: hidden; width: 90%; text-overflow: ellipsis;" *ngIf="column.field=='clientCode'" data-toggle="tooltip" data-placement="top" title="{{element.endClientCode}}">  {{element.endClientName}}</span> -->
                        </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="task_Id" stickyEnd>
                     <mat-header-cell *matHeaderCellDef class="custom_th colw-7">&nbsp;
                     </mat-header-cell>
 
                     <mat-cell *matCellDef="let element" class="custom_td colw-7" style="">
                        <!-- &nbsp; -->
                        <div *ngIf="element.masterStatus!=0 || element.viewdocsstatus!=0" class="slider_left row_{{candidateList.data.indexOf(element) + 1}}"
                           (mouseenter)="OpenSlider(candidateList.data.indexOf(element) + 1) " (mouseleave)="auxclick(candidateList.data.indexOf(element) + 1)">
                           <ul>
                              <li class="arrow_left">
                                 <span>
                                   <img
                                     src="../../assets/images/icons/ic-expand-more.svg"
                                     alt="ic-expand-more"
                                   />
                                 </span>
                               </li>
                             
                              <li *ngIf="element.masterStatus>0">
                                 <span  data-toggle="tooltip" data-placement="top" data-tooltip="Take action" data-tooltip-location="left"><img
                                       src="../../assets/images/icons/ic-send-offer-Draft.svg" alt="ic-send-offer" (click)="
                                                                  RedirectToTakeAction(element.task_Id, element.gci_Id,element.candidateName)" /></span>
                              </li>
                              <li *ngIf="element.viewdocsstatus>0">
                                 <span data-toggle="tooltip" data-placement="top" data-tooltip="View Docs" data-tooltip-location="left">
                                    <img src="../../assets/images/icons/ic-eye.svg" alt="ic-eye.svg"
                                       (click)="ViewSentDocs(element.task_Id, element.gci_Id,element.candidateName)" /></span>
                              </li>
                           </ul>
                        </div>
                        </mat-cell>
    
                    </ng-container>
    
                    <mat-header-row *matHeaderRowDef="columnsToDisplay.concat(['task_Id']); sticky: true" ></mat-header-row>
    
                    <mat-row *matRowDef="let row; columns: columnsToDisplay.concat(['task_Id']); let i= index"
                        class="example-element-row">
                     
                     </mat-row>
                     <!-- <mat-row role="row" class="mat-row cdk-row example-element-row justify-content-center align-content-center">
                        <mat-cell role="gridcell" class="">
                           You dont have any pending paperwork to sign
                        </mat-cell>
                     </mat-row> -->
                </mat-table>
                <div class="clearfix clear-fix"></div>
            </div>
    
        
       </div>
       <div class="clearfix clear-fix"></div>
    </div>
    <div class="clear-fix clearfix"></div>
 </div>
 <div class="custom_modal" id="upload_adhoc_docs" [ngStyle]="{'display':supportingDocStyle}">
   <div class="custom_modal_wrap">
     <div class="custom_modal_header">
       <h5 class="modal-title">Supporting Doc List</h5>
       <button class="close">
         <span><img src="../assets/images/icons/ic-close.svg" alt="ic-close" (click)="OpenSupportDocPopup()" /></span>
       </button>
     </div>
     <div class="custom_modal_body">
       <div class="documents_mainwrap">
         <div class="doc_row" *ngFor="let item of UploadedSupportingDocs;let i = index">
           <!-- <div class="doc_type">{{item.DocType}}</div> -->
           <div class="doc_title">{{item.docName}}</div>
           <!-- <div class="doc_date">{{item.UploadedDate}}</div> -->
           <div class="doc_action">
             <span><img src="../assets/images/icons/ic-eye.svg" alt="ic-doc-view"
                 (click)="ViewUploadedDocs(item.fileData,item.docName)" /></span>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>
 